import { sendPost } from '../http.js'

const api = {
	'getClassCategoryAPI': '/xiaohongshu/category', // 小红书课程分类
	'getBrandAPI': '/xiaohongshu/brand', // 小红书根据分类获取品牌
	'uploadXhsPicAPI': '/xiaohongshu/upload_material', // 小红书上传图片素材
	'getClassesListAPI': '/xiaohongshu/product_list', // 小红书课程列表
	'handleClassAPI': '/xiaohongshu/product_save', // 小红书课程添加/编辑
	'classGroundingAPI': '/xiaohongshu/update_status', // 小红书课程上下架
	'updateStockAPI': '/xiaohongshu/update_stock', // 小红书课程修改库存
    'getClassDetailInfoAPI': '/xiaohongshu/product_info' // 获取课程详情接口(编辑时老数据回显)
}

export default {
    getClassCategoryAPI(params) {
        return sendPost(api.getClassCategoryAPI, params)
    },
    getBrandAPI(params) {
        return sendPost(api.getBrandAPI, params)
    },
    uploadXhsPicAPI(params) {
        return sendPost(api.uploadXhsPicAPI, params)
    },
    getClassesListAPI(params) {
        return sendPost(api.getClassesListAPI, params)
    },
    handleClassAPI(params) {
        return sendPost(api.handleClassAPI, params)
    },
    classGroundingAPI(params) {
        return sendPost(api.classGroundingAPI, params)
    },
    updateStockAPI(params) {
        return sendPost(api.updateStockAPI, params)
    },
    getClassDetailInfoAPI(params) {
        return sendPost(api.getClassDetailInfoAPI, params)
    },
    
}